export default "__VITE_ASSET__CIORn42u__"